import axios from "@/axios";
import * as types from '@/store/mutation-types'

export default {
    namespaced: true,

    state: {
        places: []
    },

    actions: {
        fetchAll({ commit }) {
            return axios.get('/SettingsAttend/WorkPlaces').then(({ data }) => {
                commit(types.STORE_WORK_PLACES, data)
                return data
            })
        },

        create({ commit }, { name }) {
            return axios.post('/SettingsAttend/WorkPlaces', { name }).then((data) => {
                return data
            })
        },

        update({ commit }, { id, name }) {
            return axios.put(`/SettingsAttend/WorkPlaces/${id}`, { name }).then((data) => {
                return data
            })
        },

        delete({ commit }, { id }) {
            return axios.delete(`/SettingsAttend/WorkPlaces/${id}`)
        }
    },

    mutations: {
        [types.STORE_WORK_PLACES](state, places) {
            state.places = places
        }
    },

    getters: {
        getById: state => id => state.places.find(c => c.id === id)
    }
}